import Vue from 'vue';

import {
  APP_SIZE_SET,
  APP_HEADER_SIDEBAR_SHOW_FLAG_TOGGLE,
  APP_LOADER_FLAG_TOGGLE,
  APP_POPUP_OPEN,
  APP_POPUP_CLOSE,
} from '../mutations-types'

const state = {
  appSize: null,
  isHeaderSidebarShow: false,
  isLoaderActive: false,
  popupStore: {},
};

const getters = {
  appSize: state => state.appSize,
  isHeaderSidebarShow: state => state.isHeaderSidebarShow,
  isLoaderActive: state => state.isLoaderActive,
  popupStore: state => state.popupStore,
};

const mutations = {
  [APP_SIZE_SET](state) {
    Vue.set(state, 'appSize', {
      width: window.innerWidth,
      height: window.innerHeight,
    });
  },

  [APP_HEADER_SIDEBAR_SHOW_FLAG_TOGGLE](state, flag) {
    Vue.set(state, 'isHeaderSidebarShow', flag);
  },

  [APP_LOADER_FLAG_TOGGLE](state, flag) {
    Vue.set(state, 'isLoaderActive', flag);
  },

  [APP_POPUP_OPEN](state, name) {
    Vue.set(state.popupStore, name, true);
  },

  [APP_POPUP_CLOSE](state, name) {
    if (state.popupStore[name]) {
      Vue.set(state.popupStore, name, false);
    } else {
      console.error('POPUP | not found popup ' + name)
    }
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};